import { render, staticRenderFns } from "./headerPage.vue?vue&type=template&id=6d2040e0&scoped=true"
import script from "./headerPage.vue?vue&type=script&lang=js"
export * from "./headerPage.vue?vue&type=script&lang=js"
import style0 from "./headerPage.vue?vue&type=style&index=0&id=6d2040e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2040e0",
  null
  
)

export default component.exports